import * as React from 'react';
import Tile from '..';
import { getText } from '../../../helpers';
import buildUrl from '../../../utilities/build-url';
import buildImageUrl from '../../../utilities/build-image-url';

export default function BlueprintTile(props: BlueprintTileProps) {
    const { className, dataProfile, newTab } = props;
    const { AbsoluteBlueprintName, MktplaceBlueprintUrlName, MarketplaceBlueprintName, MarketplaceBlueprintShortDesc, ThumbnailImageFilePath, MarketplaceDataProviders, MarketplaceBlueprintDateAdded, MarketplaceBlueprintEnhancementDate, KeyMarketplaceBlueprint } = dataProfile;
    const langCode = getText('langCode');
    const blueprintPathSegment = buildUrl(AbsoluteBlueprintName || MktplaceBlueprintUrlName || MarketplaceBlueprintName, KeyMarketplaceBlueprint);
    let url = `/${langCode}/blueprints/${blueprintPathSegment}`;
    if (newTab) url = window.location.origin.concat(url);
    const arrDataProviders = Object.values(MarketplaceDataProviders);
    const dataProviders = arrDataProviders && arrDataProviders.length > 0 && arrDataProviders[0] && arrDataProviders[0].toString();
    const dataProviderForDisplay = dataProviders && dataProviders.split('|').length > 1 ? getText('generic.multipleVendor') : Object.values(MarketplaceDataProviders)[0];
    const dataProviderDisplayObject = dataProviderForDisplay && dataProviderForDisplay.MarketplaceDataProvider ? dataProviderForDisplay.MarketplaceDataProvider : dataProviderForDisplay;

    const pathOverride = buildImageUrl(ThumbnailImageFilePath);

    return (
        <Tile
            className={className}
            tileType="Blueprint"
            provider={dataProviderDisplayObject}
            name={MarketplaceBlueprintName}
            description={MarketplaceBlueprintShortDesc || ''}
            buttonText={getText('generic.viewBlueprint')}
            imgUrl={pathOverride}
            url={url}
            addedDate={MarketplaceBlueprintDateAdded}
            enhancementDate={MarketplaceBlueprintEnhancementDate}
            id={KeyMarketplaceBlueprint}
        />
    );
}
